import React from 'react';

function QuizProgressBar({ progress }) {
    return (
        <div className="quiz-progress-track">
            <div className="quiz-progress-fill" style={{ width: `${progress}%` }} />
        </div>
    );
}

export default QuizProgressBar;
